import { AnnotationComponentProps } from "@routes/Article/components/StoryElements/Annotation/utils/types";

export default function AnnotationComponentItalics({
  children,
}: AnnotationComponentProps): React.ReactElement {
  return <i>{children}</i>;
}
